import { useAccountsWithMap } from "./useAccountsWithMap";

/**
 * Hook that fetches accounts with job:new permission and returns both the list and a Map for lookups.
 */
export function useAccountsForJobSubmit() {
  return useAccountsWithMap({ permission: "job:new" });
}
